import { render, staticRenderFns } from "./modoCapturaSelect.vue?vue&type=template&id=70d72dd4&scoped=true"
import script from "./modoCapturaSelect.vue?vue&type=script&lang=js"
export * from "./modoCapturaSelect.vue?vue&type=script&lang=js"
import style0 from "./modoCapturaSelect.vue?vue&type=style&index=0&id=70d72dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d72dd4",
  null
  
)

export default component.exports